var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input',{attrs:{"type":"textarea","rows":_vm.rows || 5,"placeholder":_vm.placeholder,"value":_vm.asString},on:{"blur":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }